import React from "react";
import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import img from '../../img/Fee/img.png'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#F8F8F8]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[50px] xl:mt-[90px]">
                <div className="flex flex-col xl:flex-row justify-between gap-[50px] items-center">
                    <div>
                        <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather"><Trans>{t('fees.1')}</Trans></p>
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd"><Trans>{t('fees.2')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd"><Trans>• {t('fees.3')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd"><Trans>• {t('fees.4')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd"><Trans>{t('fees.5')}</Trans></p>
                        <Button className={"mt-[30px] xl:mt-[40px]"}/>
                    </div>
                    <img src={img} className="mx-auto xl:mx-0" alt="" />
                </div>
            </div>
        </div>
    );
}

export default Main;